import 'twin.macro'
import 'styled-components/macro'
import { cardboardTypographyConfig as typographyConfig } from '@getcircuit/tailwind/cardboardTypography'
import { ClassName, LiBox, Spec } from './Typography'

export const CardboardTypography = () => {
  return (
    <div tw="space-y-8">
      <h2 tw="text-heading-default">Cardboard Typography</h2>
      <ul
        css={`
          grid-template-rows: repeat(8, minmax(0, 1fr));
        `}
        tw="grid grid-flow-col gap-4"
      >
        {/* Start of Light */}
        <LiBox>
          <div tw="text-title-light">Title</div>
          <ClassName>.text-title-light</ClassName>
          <Spec config={typographyConfig.light.title} />
        </LiBox>
        <LiBox>
          <div tw="text-heading-light">Heading</div>
          <ClassName>.text-heading-light</ClassName>
          <Spec config={typographyConfig.light.heading} />
        </LiBox>
        <LiBox>
          <div tw="text-subheading-light">Subheading</div>
          <ClassName>.text-subheading-light</ClassName>
          <Spec config={typographyConfig.light.subheading} />
        </LiBox>
        <LiBox>
          <div tw="text-subheading2-light">Subheading2</div>
          <ClassName>.text-subheading2-light</ClassName>
          <Spec config={typographyConfig.light.subheading2} />
        </LiBox>
        <LiBox>
          <div tw="text-body-light">Body</div>
          <ClassName>.text-body-light</ClassName>
          <Spec config={typographyConfig.light.body} />
        </LiBox>
        <LiBox>
          <div tw="text-button-light">Button</div>
          <ClassName>.text-button-light</ClassName>
          <Spec config={typographyConfig.light.button} />
        </LiBox>
        <LiBox>
          <div tw="text-caption-light">Caption</div>
          <ClassName>.text-caption-light</ClassName>
          <Spec config={typographyConfig.light.caption} />
        </LiBox>
        <LiBox>
          <div tw="text-tiny-light">Tiny</div>
          <ClassName>.text-tiny-light</ClassName>
          <Spec config={typographyConfig.light.tiny} />
        </LiBox>

        {/* Start of Default */}
        <LiBox>
          <div tw="text-title-default">Title</div>
          <ClassName>.text-title-default</ClassName>
          <Spec config={typographyConfig.default.title} />
        </LiBox>
        <LiBox>
          <div tw="text-heading-default">Heading</div>
          <ClassName>.text-heading-default</ClassName>
          <Spec config={typographyConfig.default.heading} />
        </LiBox>
        <LiBox>
          <div tw="text-subheading-default">Subheading</div>
          <ClassName>.text-subheading-default</ClassName>
          <Spec config={typographyConfig.default.subheading} />
        </LiBox>
        <LiBox>
          <div tw="text-subheading2-default">Subheading2</div>
          <ClassName>.text-subheading2-default</ClassName>
          <Spec config={typographyConfig.default.subheading2} />
        </LiBox>
        <LiBox>
          <div tw="text-body-default">Body</div>
          <ClassName>.text-body-default</ClassName>
          <Spec config={typographyConfig.default.body} />
        </LiBox>
        <LiBox>
          <div tw="text-button-default">Button</div>
          <ClassName>.text-button-default</ClassName>
          <Spec config={typographyConfig.default.button} />
        </LiBox>
        <LiBox>
          <div tw="text-caption-default">Caption</div>
          <ClassName>.text-caption-default</ClassName>
          <Spec config={typographyConfig.default.caption} />
        </LiBox>
        <LiBox>
          <div tw="text-tiny-default">Tiny</div>
          <ClassName>.text-tiny-default</ClassName>
          <Spec config={typographyConfig.default.tiny} />
        </LiBox>

        {/* Start of Heavy */}
        <LiBox>
          <div tw="text-title-heavy">Title</div>
          <ClassName>.text-title-heavy</ClassName>
          <Spec config={typographyConfig.heavy.title} />
        </LiBox>
        <LiBox>
          <div tw="text-heading-heavy">Heading</div>
          <ClassName>.text-heading-heavy</ClassName>
          <Spec config={typographyConfig.heavy.heading} />
        </LiBox>
        <LiBox>
          <div tw="text-subheading-heavy">Subheading</div>
          <ClassName>.text-subheading-heavy</ClassName>
          <Spec config={typographyConfig.heavy.subheading} />
        </LiBox>
        <LiBox>
          <div tw="text-subheading2-heavy">Subheading2</div>
          <ClassName>.text-subheading2-heavy</ClassName>
          <Spec config={typographyConfig.heavy.subheading2} />
        </LiBox>
        <LiBox>
          <div tw="text-body-heavy">Body</div>
          <ClassName>.text-body-heavy</ClassName>
          <Spec config={typographyConfig.heavy.body} />
        </LiBox>
        <LiBox>
          <div tw="text-button-heavy">Button</div>
          <ClassName>.text-button-heavy</ClassName>
          <Spec config={typographyConfig.heavy.button} />
        </LiBox>
        <LiBox>
          <div tw="text-caption-heavy">Caption</div>
          <ClassName>.text-caption-heavy</ClassName>
          <Spec config={typographyConfig.heavy.caption} />
        </LiBox>
        <LiBox>
          <div tw="text-tiny-heavy">Tiny</div>
          <ClassName>.text-tiny-heavy</ClassName>
          <Spec config={typographyConfig.heavy.tiny} />
        </LiBox>
      </ul>
    </div>
  )
}
